export default theme => ({
  dialogPaper: {
    overflow: 'initial',
    backgroundColor: theme.palette.blue.main,
    color: theme.palette.white.main,
    padding: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3),
      margin: theme.spacing(3),
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1),
      margin: theme.spacing(1),
    },
    '& > *': {
      position: 'relative',
    },
  },
  closeIcon: {
    position: 'absolute',
    top: 0,
    right: 0,
    transform: 'translate(50%,-50%)',
    [theme.breakpoints.down('sm')]: {
      height: 40,
      width: 40,
      '& svg': {
        height: 25,
        width: 25,
      },
    },
    [theme.breakpoints.down('xs')]: {
      height: 32,
      width: 32,
      minHeight: 32,
      right: theme.spacing(4),
      '& svg': {
        height: 20,
        width: 20,
      },
    },
  },
  dialogContent: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    '& > *': {
      width: '100%',
      paddingLeft: theme.spacing(3),
      '&:first-child': {
        paddingRight: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
          paddingRight: 0,
        },
      },
      '&:last-child': {
        paddingLeft: theme.spacing(5),
        [theme.breakpoints.down('sm')]: {
          paddingLeft: theme.spacing(3),
        },
      },
      '& > *': {
        paddingBottom: theme.spacing(2),
      },
    },
  },
  desc: {
    position: 'relative',
    '&:before': {
      content: '"\\002014"',
      position: 'absolute',
      left: theme.spacing(-3),
      color: theme.palette.secondary.color,
    },
  },
});
